var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon search-icon",
    "aria-labelledby": titleId,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.9 19.7",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Search Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A magnifying glass icon.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "search-path",
    fill: "none",
    stroke: "#848F91"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M18.5 18.3l-5.4-5.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2d0c0c09d9a11ea735ad4be351f67e10.svg";
export { ForwardRef as ReactComponent };